import React from 'react';
import './Footer.css';
import config from './Config';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer_logo">
                {config.brandname}
            </div>

            <div className="footer_links">
                <a href="#hero">About</a>
                <a href="/privacypolicy">Privacy Policy</a>
                <a href="/terms">Terms of Service</a>
            </div>

            <div className="footer_socials">
                <a href={config.facebooklink}>Facebook</a>
                <a href={config.instagramlink}>Instagram</a>
            </div>

            <div className="footer_copy">
                &copy; {new Date().getFullYear()} {config.brandname}. All rights reserved.
            </div>
        </footer>
    );
};

export default Footer;
